export const DATA_INTEGRATOR_PAGES_ORDER_FOR_PERMISSIONS: string[] = [
  'archive_file',
  'archive_directory',
  'system',
  'term',
  'public_agent_module_permission',
  'group_module_permission',
]
